<app-page-header
  title="Home"
  active_item="Usuários"
  titleLink="/reports"
></app-page-header>
<div class="loading-wallet" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>
<h5>{{ "common.userConfig" | translate }}</h5>
<form [formGroup]="user">
  <div class="row">
    <div class="col-12">
      <div class="card rounded-10 shadow" *ngIf="!isInsert">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <div class="card-title mb-0">{{ "common.users" | translate }}</div>
          <button
            type="button"
            class="our-button btn btn-pill btn-primary float-end"
            (click)="openInsert()"
          >
            <i class="fe fe-plus"></i>{{ "common.newUser" | translate }}
          </button>
        </div>
        <div class="card-body">
          <div class="scrollable-layout">
            <div class="table-responsive our-table">
              <table class="table table-striped text-nowrap mb-0">
                <thead class="border-top">
                  <tr>
                    <th>{{ "common.email" | translate }}</th>
                    <th>{{ "common.name" | translate }}</th>
                    <th>{{ "common.permission" | translate }}</th>
                    <th class="text-center">Reset</th>
                    <th class="text-center">
                      {{ "common.active" | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let user of users">
                    <td>{{ user.email }}</td>
                    <td>{{ user.name }}</td>
                    <td>
                      <span *ngFor="let role of user.roles; let last = last">
                        {{
                          user.roles
                        }}<span *ngIf="!last">, </span>
                      </span>
                    </td>
                    <td class="text-center">
                      <button
                        type="button"
                        class="btn-blue-dp"
                        title="Reset"
                        (click)="onResetClick(user)"
                        [disabled]="resettingId === user.id || !allowedByRole"
                      >
                        <i class="fe fe-rotate-ccw"></i>
                      </button>
                    </td>
                    <td class="text-center">
                      <label class="custom-switch">
                        <input
                          type="checkbox"
                          class="custom-switch-input"
                          [checked]="user.active"
                          (click)="
                            onToggleClick($event, modalConfirmEnable, user)
                          "
                        />
                        <span class="custom-switch-indicator"></span>
                      </label>
                    </td>
                  </tr>
                  <tr *ngIf="users.length == 0">
                    <td colspan="5">{{ "common.noUsersFound" | translate }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="card rounded-10 shadow" *ngIf="isInsert">
        <div class="card-header">
          <div class="card-title mb-0">
            {{ "common.createUser" | translate }}
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-xl-4 col-lg-6 col-sm-6">
              <div class="form-group">
                <label>{{ "common.email" | translate }}</label>
                <input
                  [formControl]="user.controls.email"
                  class="form-control"
                  type="email"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      user.controls.email.invalid && isSubmitted
                  }"
                />
                <div class="invalid-feedback">
                  Email inválido ou obrigatório
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-6 col-sm-6">
              <div class="form-group">
                <label>{{ "common.name" | translate }}</label>
                <input
                  [formControl]="user.controls.name"
                  class="form-control"
                  type="text"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      user.controls.name.invalid && isSubmitted
                  }"
                />
                <div class="invalid-feedback">Nome é obrigatório</div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-6 col-sm-6">
              <div class="form-group">
                <label>{{ "common.users" | translate }}</label>
                <select
                  [formControl]="user.controls.rolesAccount"
                  class="form-select"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      user.controls.rolesAccount.invalid && isSubmitted
                  }"
                >
                  <option [value]="1">
                    {{ "common.standard" | translate }}
                  </option>
                  <option [value]="3">
                    {{ "common.readOnly" | translate }}
                  </option>
                </select>
                <div class="invalid-feedback">Perfil é obrigatório</div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="form-group mt-2">
                <label class="custom-switch">
                  <input
                    type="checkbox"
                    class="custom-switch-input"
                    [formControl]="user.controls.terms"
                  />
                  <span class="custom-switch-indicator"></span>
                  <span class="custom-switch-description">
                    {{ "common.responsibilityCheck" | translate }}
                  </span>
                </label>
                <div
                  *ngIf="!user.controls.terms.value && isSubmitted"
                  class="text-danger small mt-1"
                >
                  Você deve aceitar os termos.
                </div>
              </div>
            </div>
          </div>

          <button
            type="button"
            class="btn btn-pill btn-primary float-start"
            (click)="return()"
          >
            <i class="fe fe-arrow-left"></i>{{ "common.back" | translate }}
          </button>
          <button
            type="button"
            class="btn btn-pill btn-primary float-end"
            (click)="add()"
          >
            <i class="fe fe-plus"></i>{{ "common.add" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
<ng-template #modalConfirmEnable let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">
        {{ selectedUser.active ? "Desativar" : "Ativar" }} usuário?
      </h5>
      <button
        type="button"
        class="btn-close"
        (click)="modal.dismiss(); loadUsers()"
      ></button>
    </div>
    <div class="modal-body">
      <p>
        Deseja realmente {{ selectedUser.active ? "desativar" : "ativar" }} o
        usuário <b>{{ selectedUser.name }}</b
        >?
      </p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="modal.dismiss(); loadUsers()">
        Cancelar
      </button>
      <button
        class="btn btn-{{ selectedUser.active ? 'danger' : 'primary' }}"
        (click)="toggleActive(selectedUser)"
      >
        {{ selectedUser.active ? "Desativar" : "Ativar" }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #requestTOTPCode let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Informe o token de autenticação</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click'); isLoaded = true"
    ></button>
  </div>
  <div class="modal-body">
    <div class="form-group mt-2">
      <p *ngIf="errorMessage.length > 0" class="text-danger">
        {{ errorMessage }}
      </p>
    </div>
    <div class="form-group mb-3">
      <input
        type="text"
        class="form-control"
        id="authToken"
        placeholder="Token"
        [(ngModel)]="validationCode"
        (keyup.enter)="validateTotp()"
      />
      <button
        (click)="pasteTotpCode()"
        class="btn btn-primary btn-block btn-colar h-30 w-30 mx-auto mt-2 mb-1"
      >
        {{ "login.totp.pasteButton" | translate }}
      </button>
    </div>
  </div>
  <div class="modal-footer text-center">
    <button
      type="submit"
      class="btn btn-lg btn-primary btn-pill mx-auto d-block"
      (click)="validateTotp()"
      [disabled]="validatingTotp"
    >
      VALIDAR
    </button>
  </div>
</ng-template>
